<template>
  <submission-form></submission-form>
</template>

<script>
import SubmissionForm from "component/submission-form";

export default {
  name: "project-submission",
  components: {
    SubmissionForm
  },
}
</script>

<style scoped lang="scss">

</style>